<template>
  <div class="repchart_axes">
    <div
      v-if="viewProps.colValue.key === 'strategy'"
      class="repchart_axes_chart repchart_axes_chart_oop"
    >
      <ChartAxes
        class="repchart_axes_chart_axis"
        style="
          --axis-space: var(--axes-axis-space);
          --axis-height: auto;
          --clr-axis-line-tick: rgba(0, 0, 0, 0.25);
          --first-tick-opacity: 0;
          --axis-y-justify-content: flex-end;
          --axis-y-padding: 0 0.325rem 0 0;
        "
        :YTicks="t_strategy"
        :hasX="false"
        :hasLinesY="true"
        :hasLineY="false"
      />
      <!-- --clr-axis-line-tick: red; -->
    </div>

    <div
      v-if="viewProps.display_oop"
      class="repchart_axes_chart repchart_axes_chart_oop"
    >
      <!-- {{ t_oop }} -->
      <div
        class="gw_axes_axis_tick gw_axes_axis_tick_line"
        :style="`bottom: ${t_oop.normalized * 100}%;`"
        v-html="
          l_key === 'ev'
            ? getEvHtml({
                ...bettingInfo,
                ev: t_oop.val,
                simple: true,
                unit: ``,
                percent_css_class: ``,
                percentUnit: `%`,
              })
            : t_oop.val
        "
      ></div>
    </div>
    <div
      v-if="viewProps.display_ip"
      class="repchart_axes_chart repchart_axes_chart_ip"
    >
      <div
        class="gw_axes_axis_tick gw_axes_axis_tick_line"
        :style="`${viewProps.display_oop ? 'top' : 'bottom'}: ${t_ip.normalized * 100}%;`"
        v-html="
          l_key === 'ev'
            ? getEvHtml({
                ...bettingInfo,
                ev: t_ip.val,
                simple: true,
                unit: ``,
                percent_css_class: ``,
                percentUnit: `%`,
              })
            : t_ip.val
        "
      ></div>
    </div>

    <div class="repchart_axes_legend repchart_axes_chart_center">
      <!-- <slot name="col_name" :item="item"></slot> -->
    </div>
  </div>
</template>

<script>
import ChartAxes from '@/components/Charts/LineCharts/ChartAxes'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'RepChartColumn',

  components: {
    ChartAxes,
  },
  mixins: [format_mix],
  props: {
    // item: Object,
    // reportItemId: String,
    viewProps: Object,
    eveqeqrAxes: Object,
    bettingInfo: Object,
    // useHex: Boolean,
    legendVertical: Boolean,
  },
  data() {
    return {}
  },
  methods: {
    geMinMaxTicks(player) {
      const key = this.l_key
      let val = this.eveqeqrAxes ? this.eveqeqrAxes[`${player}_${key}`] : 0

      const increment = key === 'eq' || key === 'eqr' ? 100 : 1
      const decimals = key === 'eq' || key === 'eqr' ? 0 : 2

      val = this.numFixed(val * increment, decimals)
      const normalized = this.eveqeqrAxes ? this.eveqeqrAxes[`${player}_${key}_normalized`] : 0
      const res = {
        val,
        normalized,
        key,
      }
      return res
    },
  },
  computed: {
    l_key() {
      return this.viewProps.colValue.key
    },
    t_strategy() {
      return [0, 25, 50, 75, 100]
    },
    t_oop() {
      return this.geMinMaxTicks('oop')
    },
    t_ip() {
      return this.geMinMaxTicks('ip')
    },
  },
}
</script>

<style lang="scss" scoped>
.gw_axes_axis_tick {
  --tick-size: 0.7rem;
  --axis-space: var(--axes-axis-space);
  --clr-axis: var(--clr-black-4);
  --clr-axis-line-tick: rgba(0, 0, 0, 0.25);
  // --axis-y-line-inset: auto auto auto auto;

  line-height: 1;
  font-size: var(--tick-size);
  width: var(--axis-space);
  max-width: var(--axis-space);
  color: var(--clr-axis);
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 0 0.325rem 0 0;
  position: absolute;
  letter-spacing: -0.5px;
  pointer-events: none;

  height: 0px;
  &_line {
    &::before {
      content: '';
      background: var(--clr-axis-line-tick);
      position: absolute;
      height: 1px;
      width: 100vw;
      left: 100%;
    }
  }
}
.repchart {
  &_axes {
    --axes-axis-space: 2.5rem;

    z-index: 1;
    position: absolute;
    width: var(--axes-axis-space);
    margin-left: calc(var(--axes-axis-space) * -1);
    height: 100%;
    display: flex;
    flex-direction: column;

    &_chart {
      display: flex;
      flex: 1;
      position: relative;
      &_oop {
        order: 1;
        align-items: flex-end;
      }
      &_ip {
        order: 1;
        align-items: flex-end;
      }
      &_center {
        order: 2;
        align-items: flex-end;
      }
    }
    &_legend {
      height: var(--legend-height);
    }
    &_split {
      .repchart_chart_players {
        justify-content: center;
      }
      .repchart_axes_chart_oop {
        order: 1;
      }
      .repchart_axes_chart_ip {
        align-items: flex-start;
        order: 3;
      }
      .repchart_axes_chart_center {
        order: 2;
      }
    }
  }
}
</style>
